import createRoute from '@widesk-ui/tools/createRoute';
import VatModel    from '@models/shop/VatModel';

export default createRoute.table('/vats', 'shop', 'VatTable', VatModel.localize('plural'));
